import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  PRIMARY_HEADER_LINE,
  DARK_CONTAINER_FIELDS_FLOATING,
  LIGHT_CONTAINER_FIELDS_FLOATING,
  DARK_FIELDS_ON_CARD_HEADER_LINE,
} = COLORS;

const $gutter = 30;
type Props = {
  isST?: boolean;
};

export const useStyles = makeStyles<Theme, Props>((theme) =>
  createStyles({
    flexColumnContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: 15,
    },
    miniRow: {
      display: 'flex',
      gap: 5,
      flexWrap: 'wrap',
      alignItems: 'center',
    },
    heading: {
      position: 'relative',
      borderBottom: `1px solid ${DARK_FIELDS_ON_CARD_HEADER_LINE}`,
      paddingBottom: 10,
      marginBottom: 15,
      fontSize: 17,
      '&::before': {
        content: '""',
        background: PRIMARY_HEADER_LINE,
        height: '1px',
        position: 'absolute',
        width: '20%',
        bottom: '-1px',
        left: '0',
      },
    },
    flexMiniColumnContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: 5,
    },
    flexRow: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 15,
    },
    contactItem: {
      display: 'flex',
      gap: 5,
      alignItems: 'center',
      '& svg': {
        height: 20,
        width: 'auto',
        marginRight: 5,
      },
      '& > div:last-child': {
        display: 'flex',
        flexDirection: 'column',
      },
    },
    locationAndDateItemContainer: {
      background: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_FLOATING : LIGHT_CONTAINER_FIELDS_FLOATING,
      padding: '5.5px 7px',
      borderRadius: 5,
    },
    gridContainer: ({ isST }) => ({
      display: 'grid',
      gridTemplateColumns: isST ? 'repeat(2, 50%)' : 'repeat(4, 25%)',
      gap: $gutter,
      width: `calc(100% - ${$gutter * 3}px)`,

      [theme.breakpoints.down(1250)]: {
        gridTemplateColumns: 'repeat(2, 50%)',
        width: `calc(100% - ${$gutter}px)`,
      },

      [theme.breakpoints.down(950)]: {
        gridTemplateColumns: 'unset',
        width: '100%',
      },
    }),
  }),
);
